export default __webpack_public_path__ + "static/media/bench2.6c2ccb6e.png";